import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import getInitials from "../../utils/getInitials";
import { RateTableListResponse } from "../../api/rateTable";
import LoadingWrapper from "../Loading/LoadingWrapper";
import LoadingTableRow from "../Loading/LoadingTableRow";
import { Loadable } from "../Loading/Loadable";

/** Props for the RateTableListResults component */
interface RateTableListResultsProps {
  /** List of rate tables that will be displayed in the list */
  rateTables: Loadable<RateTableListResponse>;
  /** Function to execute when a rate table entry is clicked */
  onClick: (rateTableId: string) => void;
}

const formatDate = (value?: string): string =>
  value ? new Date(value).toLocaleDateString() : "";

const RateTableListResults = ({
  rateTables,
  onClick,
  children,
  ...rest
}: React.PropsWithChildren<RateTableListResultsProps>) => {
  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>Date Created</TableCell>
                <TableCell>Date Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <LoadingWrapper
                loadingInfo={rateTables}
                loadingComponent={<LoadingTableRow colSpan={6} />}
              >
                {rateTables.data.rate_tables.map((rateTable) => (
                  <TableRow
                    hover
                    key={rateTable.external_id}
                    onClick={() => onClick(rateTable.external_id)}
                  >
                    <TableCell>
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <Avatar src={""} sx={{ mr: 2 }}>
                          {getInitials(rateTable.name)}
                        </Avatar>
                        <Typography color="textPrimary" variant="body1">
                          {rateTable.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{rateTable.description}</TableCell>
                    <TableCell>{rateTable.currency_code}</TableCell>
                    <TableCell>
                      {formatDate(rateTable.created_date_utc)}
                    </TableCell>
                    <TableCell>
                      {formatDate(rateTable.last_modified_date_utc)}
                    </TableCell>
                  </TableRow>
                ))}
              </LoadingWrapper>
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {children}
    </Card>
  );
};

export default RateTableListResults;
